import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationProfileDetailsRequest extends BaseUpdateRequest {
    brandName: string;
    website: string;
    biography: string;
    parkingInstructions: string;
    arrivalInstructions: string;
}